/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react'

type HubspotFormProps = {
  formId: string
  onSubmit?: (values: Record<string, string>) => void
  afterSubmit?: () => void
  initialValues?: Record<string, string>
}

const HubspotForm = ({
  formId,
  onSubmit,
  afterSubmit,
  initialValues
}: HubspotFormProps) => {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const script = document.createElement('script')
    script.id = 'jquery-to-delete'
    script.integrity = 'sha256-/xUj+3OJU5yExlq6GSYGSHk7tPXikynS7ogEvDej/m4='
    script.crossOrigin = 'anonymous'
    script.onload = () => {
      // @ts-expect-error hubspot form lib inject via script
      if (window.hbspt) {
        // @ts-expect-error hubspot form lib inject via script
        window.hbspt.forms.create({
          region: 'na1',
          portalId: '9429913',
          formId: formId,
          target: `#hubspot-form-${formId}`,
          onFormSubmitted: () => {
            afterSubmit?.()
          },
          onFormSubmit: ($form: any) => {
            onSubmit?.(
              $form.serializeArray().reduce(
                (acc: any, item: any) => ({
                  ...acc,
                  [item.name]: item.value
                }),
                {}
              )
            )
          },
          onFormReady: ($form: any) => {
            if (initialValues) {
              Object.keys(initialValues).forEach((key) =>
                $form.find(`[name=${key}]`).val(initialValues[key])
              )
            }

            setIsLoading(false)
          }
        })
      }
    }
    script.src = 'https://code.jquery.com/jquery-3.6.0.min.js'
    document.head.appendChild(script)

    return () => {
      const scriptToDelete = document.getElementById('jquery-to-delete')
      if (scriptToDelete) {
        scriptToDelete.remove()
      }
    }
  }, [formId, onSubmit, afterSubmit, initialValues])

  return (
    <div id={`hubspot-form-${formId}`}>
      {isLoading && (
        <div className="flex items-center justify-center p-4">
          <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-accent-800"></div>
        </div>
      )}
    </div>
  )
}

export default HubspotForm
